import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { ArrowDown, XIcon } from 'tedooo-web-design-system/icons';

import Modal from 'components/modal/Modal';
import './popup.scss';
import { IPopupProps } from 'types';
import { transformToArray } from 'utils';
import Icon from '../helpers/Icon';

const Header: FC<any> = ({ children }) => <div className="popup-header">{children}</div>;

const Footer: FC<any> = ({ children }) => <div className="popup-footer">{children}</div>;

const Content: FC<any> = ({ children }) => <div className="popup-content">{children}</div>;

const Popup = ({
  children,
  className,
  isSticky,
  withOverlay,
  hide,
  isFullHeight,
  isClickOutsideDisabled,
  isDrawerInMobile,
  modalClassName,
}: IPopupProps) => {
  const processChildren = (): {
    content: null | ReactNode;
    header: null | ReactNode;
    footer: null | ReactNode;
  } => {
    const emptyArray = {
      content: null,
      header: null,
      footer: null,
    };

    if (!children) return emptyArray;

    // transform to array
    const childrenArray = transformToArray(children);

    return childrenArray.reduce((acc, child) => {
      const name = child.type?.name;

      if (name === Content.name) {
        return {
          ...acc,
          content: child,
        };
      }

      if (name === Header.name) {
        return {
          ...acc,
          header: child,
        };
      }

      if (name === Footer.name) {
        return {
          ...acc,
          footer: child,
        };
      }

      return acc;
    }, emptyArray);
  };

  const popupData = processChildren();

  return (
    <Modal
      onEsc={hide}
      onClickOutside={hide}
      withOverlay={!!withOverlay}
      isClickOutsideDisabled={isClickOutsideDisabled}
      className={classNames([modalClassName], { 'drawer-popup': isDrawerInMobile })}
    >
      <div className={classNames('popup-container', { 'full-size': isFullHeight }, [className])}>
        <ArrowDown className="arrow" onClick={hide} />
        {!isSticky && <Icon icon={<XIcon />} onClick={hide} className="icon-close" />}
        <div className="popup-inner-container">
          {popupData.header}
          {popupData.content}
          {popupData.footer}
        </div>
      </div>
    </Modal>
  );
};

Popup.Header = Header;
Popup.Footer = Footer;
Popup.Content = Content;

export default Popup;
